import { types as configTypes } from '~/org/twilio/one-support-center/shared/osc-env';
import { twilioRealm } from '../../../utils';
import { ProductIconName } from '../definitions/types';

const productionProductIconNameByCategoryId = {
  360002390473: ProductIconName.Assets,
  203263408: ProductIconName.Connections,
  115000993328: ProductIconName.Conversations,
  360002390493: ProductIconName.ElasticSipTrunking,
  360000707553: ProductIconName.Fax,
  360001002073: ProductIconName.Flex,
  360002382034: ProductIconName.Functions,
  360000042528: ProductIconName.InternetOfThings,
  203263388: ProductIconName.Messaging,
  115002472027: ProductIconName.Notify,
  203263428: ProductIconName.PhoneNumbers,
  4405455925915: ProductIconName.Privacy,
  115002445488: ProductIconName.Studio,
  203267627: ProductIconName.Twiml,
  4417650133531: ProductIconName.TwilioOrg,
  360002073773: ProductIconName.Verify,
  204018768: ProductIconName.Video,
  203267587: ProductIconName.Voice,
};

const sandboxProductIconNameByCategoryId = {
  360002584033: ProductIconName.Authy,
  360002584053: ProductIconName.Messaging,
  360001843593: ProductIconName.PhoneNumbers,
  360002573534: ProductIconName.Voice,
};

export const getProductIconNameByZendeskCategoryId = (
  categoryId: number,
): ProductIconName => {
  const realm = twilioRealm;

  const productIconNameByRealm = {
    [configTypes.Realm.prod]: productionProductIconNameByCategoryId,
    [configTypes.Realm.stage]: productionProductIconNameByCategoryId,
    [configTypes.Realm.dev]: productionProductIconNameByCategoryId,
    [configTypes.Realm.local]: sandboxProductIconNameByCategoryId,
  };

  const productIconName =
    productIconNameByRealm[realm] ||
    productIconNameByRealm[configTypes.Realm.local];

  return productIconName[categoryId] || ProductIconName.Twilio;
};
